import React, {Component} from 'react';
import {IProps, IState} from "./types";
import MessageContainer from "../MessageContainer";
import Attachment from '../Attachments'
import Upload from '../Upload'
import StopWatch from "../../components/Stopwatch/index";
import {ModuleValues} from "../../types";
import Share from "../Share";
import AuthUser from '../../components/AuthUser';
import {REDUCER_TYPE} from "../../modules/Reducer";
import {connect} from "react-redux";
import JitsiVideo from "../JitsiVideo";
import JitsiRecorder from "../../components/JitsiRecorder";

class Chat extends Component <IProps, IState> {
    constructor(props: IProps) {
        super(props);
        this.state = {
            messages: props.messages,
            chosenModule: props.chosenModule,
            loggedData: props.state.loggedData,
            jitsiData: props.state.jitsiMeeting,
            isMobile: window.innerWidth <= 1199,
        }
    }

    componentDidMount() {
        window.addEventListener('resize', this.handleResize);
    }

    componentWillUnmount() {
        window.removeEventListener('resize', this.handleResize);
    }

    handleResize = () => {
        const isMobile = window.innerWidth <= 1199;
        if (isMobile !== this.state.isMobile) {
            this.setState({ isMobile });
        }
    };

    componentDidUpdate(prevProps: Readonly<IProps>, prevState: Readonly<IState>, snapshot?: any): void {
        if (prevProps.chosenModule !== this.props.chosenModule) {
            this.setState({chosenModule: this.props.chosenModule});
        }
        if (this.state.loggedData !== this.props.state.loggedData) {
            this.setState({loggedData: this.props.state.loggedData})
        }

        if (this.state.messages !== this.props.messages) {
            this.setState({
                messages: this.props.messages
            })
        }


        if (this.state.jitsiData !== this.props.state.jitsiMeeting) {
            this.setState({
                jitsiData: this.props.state.jitsiMeeting
            })
        }
    }

    getMessageContainerClass = () => {
        let messageContainerClass: string;
        if (this.state.chosenModule === 'video') {
            messageContainerClass = 'messages-video--width';
        } else if (this.state.chosenModule === 'chat') {
            messageContainerClass = 'messages-fullscreen';
        } else {
            messageContainerClass = 'messages-other--width';
        }
        return messageContainerClass;
    };

    render() {
        const params = new URLSearchParams(window.location.search);
        const medasVoiceToken = params.get("medasVoiceToken") || "";
        const medasVoiceUrl = params.get("medasVoiceUrl") || "";
        const showRecorder = this.props.state.authUser?.role === 'Admin'
            && this.state.jitsiData?.jwt
            && this.state.jitsiData?.room
            && this.props.state.jitsiJoined
            && this.state.chosenModule === ModuleValues.VIDEO
            && medasVoiceUrl;
        return (
            <div className="chat-container clear-space-sm">
                <AuthUser/>
                {/*<ChangeLanguage/>*/}
                {/*<VideoContainer isActiveTab={this.state.chosenModule === ModuleValues.VIDEO}/>*/}
                {showRecorder && this.state.isMobile && (
                    <div className="video-frame__recorder mobile-only">
                        <JitsiRecorder
                            roomName={this.state.jitsiData.room}
                            jwtToken={this.state.jitsiData.jwt}
                            domain={this.state.jitsiData.domain}
                            medasVoiceToken={medasVoiceToken}
                            medasVoiceUrl={medasVoiceUrl}
                        />
                    </div>
                )}
                <JitsiVideo
                    isActiveTab={this.state.chosenModule === ModuleValues.VIDEO}
                    jitsiData={this.state.jitsiData}
                />
                <Attachment isActiveTab={this.state.chosenModule === ModuleValues.DOC} />
                <Share isActiveTab={this.state.chosenModule === ModuleValues.QR}/>
                <MessageContainer
                    messages={this.state.messages}
                    chatMessages={this.props.chatMessages}
                    chosenModule={this.state.chosenModule}
                    tabClass={this.getMessageContainerClass()}
                    header={showRecorder && !this.state.isMobile ? (
                        <div className="video-frame__recorder desktop-only">
                            <JitsiRecorder
                                roomName={this.state.jitsiData.room}
                                jwtToken={this.state.jitsiData.jwt}
                                domain={this.state.jitsiData.domain}
                                medasVoiceToken={medasVoiceToken}
                                medasVoiceUrl={medasVoiceUrl}
                            />
                        </div>
                    ) : undefined}
                />
                <Upload isActiveTab={this.state.chosenModule === ModuleValues.UPLOAD}/>
                <StopWatch/>
            </div>
        )
    }
}


const mapStateToProps = (state: REDUCER_TYPE) => {
    return {
        state: state
    }
}
// @ts-ignore
export default connect(mapStateToProps)(Chat)
